import React from 'react'
import Button from '~/components/_atoms/Button'
import safeParse from '~/lib/safeParse'
import { CoachInsights, Audio } from '~/components/icons/YnsIcon'
import moment from 'moment'
import Typography from '~/components/_atoms/Typography'
import { useTranslation } from '../../../hooks/useTranslation'

const InsightCard = ({ insight }) => {
  const { t } = useTranslation()
  const [listenPressed, setListenPressed] = React.useState(false)
  const recentlyAdded = moment(insight.date).isAfter(
    moment().subtract(7, 'days'),
  )
  console.log('recentlyAdded', recentlyAdded, insight.date, insight)
  return (
    <div className="grid max-w-80 grid-cols-1 items-start gap-4 xl:max-w-none xl:grid-cols-[300px_1fr]">
      <div className="relative inline-flex">
        <img
          src={insight.image}
          alt={insight.title}
          className="w-full rounded-2xl object-cover object-center"
        />
        {recentlyAdded && (
          <div className="absolute bottom-0 left-0 z-10 flex h-8 items-center justify-center rounded-bl-2xl rounded-tr-3xl border-intoo-blue-medium-400 bg-intoo-blue-medium-100 px-4 font-medium text-primary">
            <Typography variant="small" color="primary">
              {t('recently_added')}
            </Typography>
          </div>
        )}
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-4">
          <div className="font-medium text-intoo-green-coachcta">
            {insight.category}
          </div>
          <div className="text-center">{insight.author}</div>
          <div className="text-4xl leading-3">&bull;</div>
          <div>{insight.date}</div>
        </div>
        <div className="subtitle">{insight.title}</div>
        <p>
          {insight.summary &&
            safeParse(insight.summary).replace(/&nbsp;/g, ' ')}
        </p>
        <div className="grid grid-cols-[auto_auto_1fr] gap-3">
          <Button
            variant={insight.has_viewed ? 'outline' : 'solid'}
            color="secondary"
            size="sm"
            href={insight.link}
            endIcon={<CoachInsights className="stroke-current" />}
          >
            {t('read_insight')}
          </Button>
          {insight.audio && (
            <Button
              variant={listenPressed ? 'solid' : 'outline'}
              color="secondary"
              size="sm"
              onClick={() => {
                setListenPressed(!listenPressed)
              }}
              endIcon={<Audio className="stroke-current" />}
            >
              {t('listen')}
            </Button>
          )}
          {listenPressed && (
            <audio className="h-9 w-full" controls preload="metadata" autoPlay>
              <source src={insight.audio} type="audio/mpeg" />
              {t('audio_not_supported')} {t('search_insights')}
            </audio>
          )}
        </div>
      </div>
    </div>
  )
}

export default InsightCard
